import { gql } from 'apollo-angular';
import { RentDepositInfo } from '@ui/shared/model';
import { rentDepositInfoFields } from '@ui/legacy-lib';

export interface DepositInfoResponse {
  depositInfo: RentDepositInfo;
}

export interface UseRuvDepositResponse {
  useRuvDeposit: RentDepositInfo;
}

export const depositInfoQuery = gql`
  query depositInfo($propertyId: ID!) {
    depositInfo(propertyId: $propertyId) {
      ${rentDepositInfoFields}
    }
  }
`;

export const useRuvDepositMutation = gql`
  mutation useRuvDeposit($propertyId: ID!, $input: RentDepositInput) {
    useRuvDeposit(propertyId: $propertyId, input: $input) {
      ${rentDepositInfoFields}
    }
  }
`;
